import { TFunction } from "next-i18next";

import { PageContentProps } from "content/content.types";

import { QuestionsContent } from "../Questions.types";
import commonContent from "./common";

export default (t: TFunction, { locale }: PageContentProps): QuestionsContent =>
    commonContent(t, locale);
